import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthorizeService } from 'core-lib';
import { Router } from '@angular/router';
@Injectable({
  providedIn: 'root'
})
export class AuthorizedGuardService implements CanActivate {

  constructor(private authorizeSvc: AuthorizeService, private router: Router) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean | UrlTree> {

    let promise = this.authorizeSvc.checkAuthorized()
      .toPromise().then((result: boolean) => {       
        return true;
      }).catch((e: any) => {
        return this.router.parseUrl('login');
      });

    return promise;
  }
}